module.exports = __webpack_public_path__ + "img/5fdb142.png";